import { render } from "./TheDemandActionButton1.vue?vue&type=template&id=55dc500e"
import script from "./TheDemandActionButton1.vue?vue&type=script&lang=js"
export * from "./TheDemandActionButton1.vue?vue&type=script&lang=js"
script.render = render

export default script